var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"test-locator-locale",attrs:{"items":_vm.localeItems,"label":_vm.$t('locale_label'),"value":_vm.value},on:{"change":_vm.change},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('span',{attrs:{"label":item.text}},[_vm._v(_vm._s(item.text))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }